export const IconExclamationMarkAttention: {
  name: 'icon_exclamation_mark_attention-92881a40c819'
} = {
  name: 'icon_exclamation_mark_attention-92881a40c819'
}
